import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { TextField, Checkbox, FormControlLabel, Grid, Button, Dialog, DialogTitle, DialogContent, DialogContentText } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as Actions from './store/actions';
import * as validatorActions from '../../components/validator/store/actions'
import ComponentTrackingInfo from '../../components/ComponentTrackingInfo';
import { getSharedTextFieldProps } from '../../components/helpers';
import ContentLabelForm from '../content_label/ContentLabelForm';

const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
    },
    textFieldSearch: {
        marginLeft: theme.spacing.unit,
        width: '95%',
    },
    button: {
        margin: theme.spacing.unit,
    },
    editor: {
        "min-height": "150px"
    },
    root: {
        backgroundColor: theme.palette.background.paper,
        width: 500,
    },
    readOnlyMargin: {
        marginLeft: '16px'
    },
    hiddenWhenEmptyValue: {
        display: 'none'
    },
    customInput: {
        color: 'blue',
        cursor: 'pointer',
        textDecoration: 'underline'
    }
});


class LessonForm extends Component {

    state = { unscheduledDialog: false }

    handleChange = field_name => event => {

        let value = event.target.value;
        if (event.target.type === 'checkbox') {
            value = event.target.checked ? 1 : 0;
        }

        const update_data = {
            [field_name]: value
        }
        const validator = {
            field_name, value
        }

        this.props.runValidator(validator)
        this.props.updateLessonForm(update_data);
    };

    handleUnscheduled = () => {
        this.props.clearSchedule()
        this.setState({ unscheduledDialog: false })
        return true
    };

    handleCopyClick = () => {
        this.props.toggleLessonRepull(true)
        return this.props.history.push('/lesson/edit/' + this.props.copiedLesson.lesson_id)
    };

    render() {
        const { classes, view_type, theme, lesson, validator } = this.props;
        const unscheduledDialog =
            <Dialog
                open={this.state.unscheduledDialog}
                // open={true}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Schedule Toggle"}</DialogTitle>

                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <span>Warning: this will cause the lesson's schedule to be emptied</span><br></br><br></br>
                        <Button onClick={() => this.handleUnscheduled()} variant={'contained'}>Change</Button>
                        <Button style={{ float: 'right' }} onClick={() => this.setState({ unscheduledDialog: false })} variant={'contained'}>Back</Button>
                    </DialogContentText>
                </DialogContent>
            </Dialog >
        return (
            <div className="p-24">
                {unscheduledDialog}
                <Grid container spacing={24}>
                    <Grid item xs={6}>
                        <form className={classes.container} noValidate autoComplete="off">
                            <Grid item xs={12}>

                                <TextField
                                    required
                                    id="LessonName"
                                    label="Lesson Name"
                                    value={lesson.LessonName}
                                    onChange={this.handleChange('LessonName')}
                                    error={validator.filter(v => v.field_name === 'LessonName')[0].error}
                                    helperText={validator.filter(v => v.field_name === 'LessonName')[0].error_msg}
                                    {...getSharedTextFieldProps(view_type, classes)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id="LessonDescription"
                                    label="Lesson Description"
                                    value={lesson.LessonDescription}
                                    onChange={this.handleChange('LessonDescription')}
                                    {...getSharedTextFieldProps(view_type, classes)}
                                    className={(lesson.LessonDescription === (undefined || '') && view_type === 'detail') ? [classes.hiddenWhenEmptyValue, classes.textField] : classes.textField}
                                />
                            </Grid>
                            {/* <Grid item xs={12}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            style={{ marginLeft: '10px' }}
                                            checked={(lesson.Active === 1 || lesson.Active === true)}
                                            onChange={(view_type === 'detail') ? undefined : this.handleChange('Active')}
                                            disableRipple={view_type === 'detail'}
                                            value="Active"
                                            color="primary"
                                        />
                                    }
                                    label="Active"
                                />
                            </Grid> */}
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            style={{ marginLeft: '10px' }}
                                            checked={(lesson.Unscheduled === 1 || lesson.Unscheduled === true)}
                                            onChange={() => this.setState({ unscheduledDialog: true })}
                                            disableRipple={view_type === 'detail'}
                                            disabled={view_type === 'detail'}
                                            value="Unscheduled"
                                            color="primary"
                                        />
                                    }
                                    label="Unscheduled"
                                />
                            </Grid>
                            <Grid item xs={12} style={{ paddingTop: '20px' }}>
                                <ContentLabelForm
                                    labelList={this.props.contentLabelList}
                                    component_reference={'lesson'}
                                    component_reference_id={lesson.lesson_id}
                                    baseComponent={lesson}
                                    updateFunction={this.props.updateLessonForm}
                                    view_type={view_type}
                                />
                            </Grid>
                        </form>
                    </Grid>
                    <Grid item xs={6}>
                        <ComponentTrackingInfo
                            editInfo={this.props.editInfo}
                            view_type={this.props.view_type}
                            classes={classes}
                        />
                        {this.props.copiedLesson ?
                        <TextField
                            id="Copied Lesson Name"
                            label="Copied Lesson Name"
                            value={this.props.copiedLesson.LessonName}

                            inputProps={{ className: classes.customInput, onClick: () => this.handleCopyClick() }}
                            {...getSharedTextFieldProps('detail', classes)}
                        />
                        :
                        null
                    }
                    </Grid>
                    
                </Grid>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getLesson: Actions.getLesson,
        updateLessonForm: Actions.updateLessonForm,
        runValidator: validatorActions.runValidator,
        clearSchedule: Actions.clearSchedule,
        toggleLessonRepull: Actions.toggleLessonRepull,
    }, dispatch);
}

function mapStateToProps({ lessonApp, validator, contentLabelReducer }) {
    return {
        lesson: lessonApp.lessons.currentLesson,
        validator: validator.list,
        editInfo: lessonApp.lessons.editInfo,
        contentLabelList: contentLabelReducer.contentLabelReducer.contentLabelList,
        copiedLesson: lessonApp.lessons.copiedLesson,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(LessonForm)));



// WEBPACK FOOTER //
// src/main/content/lesson/LessonForm.js